import React, {Component, PropTypes} from 'react'
import {Row, Col} from 'react-bootstrap'
import extract from '../../core/extract'
import phonez from '../../core/phonez'
import Card from '../../core/components/Card'
import Icon from '../../core/components/Icon'
import i18n from '../i18n'
import {CONTACT_PATRIMONY_LINK_TYPES, CONTACT_LOT_LINK_TYPES, Contact} from '../models'
import style from './ContactCard.less'
import PatrimonyUserModal from './patrimonycontact/PatrimonyUserModal'

function mediumFilter(type) {
    return (medium) => {
        return medium.contactInfoType == type
    }
}


class ContactCard extends Component {
    static propTypes = {
        query: PropTypes.object.isRequired,
        lot: PropTypes.object
    }

    state = {}

    _openModal = (event) => {
        event.stopPropagation()
        this.setState({showModal: true})
    }

    _closeModal = () => {
        this.setState({showModal: false})
    }

    _renderModal = () => {
        const {contact} = this.props

        return (
            <PatrimonyUserModal
                patrimonyContact={contact}
                show={this.state.showModal}
                onHide={this._closeModal} />
        )
    }

    _modalHeader = () => {
        const {contact, query} = this.props

        const primaryLinkedWith = Contact.filterLinkedWith(contact, {patrimony: query.patrimonyUids, lot: query.lotUid})[0]
        return (<div>
            <div className={style.action} onClick={this._openModal.bind(this)} title={i18n.patrimonyUser.title[contact.patrimonyUserState.stateType]}>
                <Icon icon={'gear'} size='xs' />
            </div>

            <h5>{primaryLinkedWith ? Contact.extractLinkedWith(i18n.patrimonyContactLinkTypeEnum, primaryLinkedWith) : i18n.patrimonyContact}</h5>

        </div>)
    }

    render() {
        const {contact, query, ...others} = this.props

        const primaryLinkedWith = Contact.filterLinkedWith(contact, {patrimony: query.patrimonyUids, lot: query.lotUid})[0]

        return (
            <div className={style.default}>
                <Card justified active
                    kind='tab'
                    header={this._modalHeader()}
                    status={CONTACT_PATRIMONY_LINK_TYPES.indexOf(primaryLinkedWith && primaryLinkedWith.linkType) >= 0 && 'success'} /*ne fonctionne pas, doit avoir un enfant h3*/
                    {...others}>
                    <div style={{float: 'right'}} title={i18n.patrimonyUser.stateToTooltip[contact.patrimonyUserState.stateType]}>
                        <Icon icon={i18n.patrimonyUser.stateToIcon[contact.patrimonyUserState.stateType]} size={'sm'}/>
                    </div>
                    <div className={style.name}>
                        <h5>> {contact.name.firstName} {contact.name.lastName} {contact.name.value}</h5>
                    </div>
                    <div className={style.detail}>
                        <h5>{i18n.contactInformation}</h5>
                        <ul className={style.contact}>
                            {contact.patrimonyUserState.login && (
                                <li key={contact.patrimonyUserState.login}>
                                    <Icon icon='user' size='sm' title={i18n.userAccount}/>
                                    <span> {contact.patrimonyUserState.login}</span>
                                </li>
                            )}
                        </ul>
                        <ul className={style.contact}>
                            {contact.contacts.filter(mediumFilter('Phone')).slice(0, 2).map((medium, index) => (
                                <li key={index}>
                                    <Icon icon='phone' size='xs' title={i18n.phone}/>
                                    <span> {phonez(medium.phone).format()}</span>
                                </li>
                            ))}
                        </ul>
                        <ul className={style.contact}>
                            {contact.contacts.filter(mediumFilter('Mail')).slice(0, 1).map((medium, index) => (
                                <li 
                                    className={style.mail}
                                    key={index}>
                                    <Icon icon='mail' size='xs' title={i18n.email}/>
                                    <span> {medium.mail}</span>
                                </li>
                            ))}
                        </ul>
                        <ul className={style.contact}>
                            {contact.contacts.filter(mediumFilter('Fax')).slice(0, 2).map((medium, index) => (
                                <li key={index}>
                                    <Icon icon='fax' size='xs' title={i18n.fax}/>
                                    <span> {phonez(medium.fax).format()}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </Card>
                {this._renderModal()}
            </div>
        )
    }
}

export default ContactCard


// WEBPACK FOOTER //
// ./lib/patrimony/components/ContactCard.js